//form
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

//components
import Input from "../Input";
import { Container } from "./styles";
import Button from "../Button";
import { IGuest } from "../../Interfaces";

interface IGuestsFormProps {
  guest?: IGuest;

  handleForm: (guest: IGuest) => void;
}

const GuestsForm = ({ handleForm, guest }: IGuestsFormProps) => {
  const formSchema = yup.object().shape({
    name: yup.string().required("Nome obrigatório"),
    email: yup.string().required("E-mail obrigatório").email("E-mail inválido"),
    cpf: yup
      .string()
      .required("CPF obrigatório")
      .matches(
        /^([0-9]){3}\.([0-9]){3}\.([0-9]){3}-([0-9]){2}$/,
        "Deve estar no formato 000.000.000-00"
      ),
    birthDate: yup
      .string()
      .required("Data obrigatório")
      .matches(
        /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/,
        "Data inválida"
      ),
    phone1: yup
      .string()
      .required("Telefone obrigatório")
      .matches(
        /^\(?[1-9]{2}\)? ?(?:[2-8]|9[1-9])[0-9]{3}-?[0-9]{4}$/,
        "Telefone inválido"
      ),
    phone2: yup
      .string()
      .required("Telefone obrigatório")
      .matches(
        /^\(?[1-9]{2}\)? ?(?:[2-8]|9[1-9])[0-9]{3}-?[0-9]{4}$/,
        "Telefone inválido"
      ),
  });

  interface IInputs {
    name: string;
    email: string;
    cpf: string;
    birthDate: string;
    phone1: string;
    phone2: string;
  }

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IInputs>({
    defaultValues: {
      name: guest?.name,
      email: guest?.email,
      cpf: guest?.cpf,
      birthDate: guest?.birthDate,
      phone1: guest?.phone[0],
      phone2: guest?.phone[1],
    },
    resolver: yupResolver(formSchema),
  });

  const onSubmit = (data: IInputs): void => {
    if (guest !== undefined) {
      handleForm({ ...data, id: guest?.id, phone: [data.phone1, data.phone2] });
    } else {
      handleForm({ ...data, phone: [data.phone1, data.phone2] });
    }
  };

  return (
    <Container>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Input
          className="nameInput"
          label="Name"
          name="name"
          register={register}
          placeholder="Nome completo"
        />
        {!!errors.name && <p className="error">{errors.name.message}</p>}
        <Input
          className="emailInput"
          label="E-mail"
          name="email"
          register={register}
          placeholder="E-mail"
        />
        {!!errors.email && <p className="error">{errors.email.message}</p>}
        <Input
          className="cpfInput"
          label="Cpf"
          name="cpf"
          register={register}
          placeholder="CPF"
        />
        {!!errors.cpf && <p className="error">{errors.cpf.message}</p>}
        <Input
          className="birthDate"
          label="BirthDate"
          name="birthDate"
          register={register}
          placeholder="Data de Nascimento"
        />
        {!!errors.birthDate && (
          <p className="error">{errors.birthDate.message}</p>
        )}
        <Input
          className="phone"
          label="Phone"
          name="phone1"
          register={register}
          placeholder="Telefone"
        />
        {!!errors.phone1 && <p className="error">{errors.phone1.message}</p>}
        <Input
          className="phone"
          label="Phone"
          name="phone2"
          register={register}
          placeholder="Telefone"
        />
        {!!errors.phone2 && <p className="error">{errors.phone2.message}</p>}
        <Button className="submit">Enviar</Button>
      </form>
    </Container>
  );
};

export default GuestsForm;
